import React from "react";

import { NOUN_PRO_CHECKOUT } from "data/links";
import Link from "core/Link";

// meta
export const metaTitle = "NounPro: Royalty-free Icon Pricing | Noun Project";
export const metaDescription =
    "With a NounPro account, you get a perpetual, non-exclusive, worldwide right to use unlimited royalty-free icons. See our icon pricing today!";

// Hero
export const mainHeroTitle = "NounPro Icon Subscription";
export const heroSubTitle =
    "Unleash your creativity with unlimited access to the world's most diverse collection of icons.";

export const heroButtons = [
    {
        text: `Get Started`,
        url: NOUN_PRO_CHECKOUT.replace(":planType", PRO_YEARLY_PLAN),
        darkMode: true
    }
];

// The NounPro Difference
import Eyedropper from "core/IllustrativeIcons/Eyedropper";
import Download from "core/IllustrativeIcons/Download";
import Apps from "core/IllustrativeIcons/Apps";

export const headingTitle = "NounPro Benefits";
export const subTextTitle =
    "Get unlimited access to professionally curated, royalty-free icons, editing, and apps while supporting creators around the world.";

export const sections = [
    {
        image: <Download />,
        text:
            "Download unlimited PNG & SVG icons royalty-free, no need to attribute"
    },
    {
        image: <Apps />,
        text:
            "Bring millions of icons into your workflow with our apps and plugins"
    },
    {
        image: <Eyedropper />,
        text:
            "Customize any icon’s color, size, and rotation, plus add a background shape and color"
    }
];

// FAQ Section
export const faqTitle = "Common Questions";
import { appsAndPluginsPath } from "data/links";
import { PRO_YEARLY_PLAN } from "subscriptions/data";

import { MONTHLY_PRICE_PLAN } from "core/constants";

const pluginLink = (
    <>
        The entire Noun Project icon collection can be accessed directly in your
        workflow via our{" "}
        <Link href={appsAndPluginsPath} target="_blank">
            Mac App
        </Link>{" "}
        and Adobe, Google, and Microsoft{" "}
        <Link href={appsAndPluginsPath} target="_blank">
            plugins.
        </Link>{" "}
    </>
);

export const faqValues = [
    {
        title: "Is attribution required for icons downloaded with NounPro?",
        text:
            "Noun Project pays royalties to creators around the world. All icons downloaded with a NounPro subscription are royalty-free and attribution is not required."
    },
    {
        title: "What customization options are included with a subscription?",
        text:
            "With NounPro, you can change any icon’s color, size, and rotation, plus add a background shape and color."
    },
    {
        title: "Can I use a downloaded icon multiple times?",
        text:
            "Each icon downloaded with a subscription can be used multiple times as long as it’s used for the same project and/or client."
    },
    {
        title: "What file types are included with NounPro?",
        text:
            "Subscribers have access to icon SVG and PNG files, which can be customized to fit your needs. Photos are not included in icon subscriptions."
    },
    {
        title: "What apps and plugins am I able to access?",
        text: pluginLink
    },
    {
        title: "How can I cancel or change my subscription?",
        text:
            "You can cancel your subscription at any time in your account settings. To upgrade from a monthly subscription to an annual subscription, please email info@thenounproject.com."
    }
];
